const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { recordPage, PROC_BROKER_ORDERS_AND_MOVEMENTS } = require('utilities/tagging.js');
const { taggingEventHandled } = require('../../../../utilities/taggingEventHandled');
PROC_BROKER_ORDERS_AND_MOVEMENTS
// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const DateFilter = require('components/commons/dateFilter/dateFilter');

// @actions
const {
  setStateOperationFilter,
  setCheckContributions,
  setCheckSubscription,
  setCheckReimbursement,
  setCheckTransfer,
  setMaxDateFilter,
  setMinDateFilter,
} = require('actions/brokerOrdersAndMovements');
const { getNewFundMovements } = require('actions/brokerContractActivities');

//@constants
const {
  BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED,
  BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED,
  BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING,
} = require('constants/index');

class ModalOrderAndMovementsFilter extends React.Component {
  constructor(props) {
    super(props);
    this.search = this.search.bind(this);
    this.onPrimaryButtonClick = this.onPrimaryButtonClick.bind(this);
    this.onSecondaryButtonClick = this.onSecondaryButtonClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    const customData = {
      event_name: "view",
      pageName: "/broker/orders-and-movements/filter",
      serviceType: "productInformation",
      interactionType: "modal",
      }
    if ((prevProps.isOpenModal !== this.props.isOpenModal) && this.props.isOpenModal) {
      recordPage(customData)
    }
      
  }

  onPrimaryButtonClick() {
    taggingEventHandled(PROC_BROKER_ORDERS_AND_MOVEMENTS, 'verifyButton');
    this.search();
  }

  onSecondaryButtonClick() {
    taggingEventHandled(PROC_BROKER_ORDERS_AND_MOVEMENTS, 'cancelButton');
    this.props.openModal();
  }

  search() {
    const { getNewFundMovements, immContract, immOrdersAndMovements, openModal } = this.props;
    const stateOperation = immOrdersAndMovements.get('stateOperation');
    const date = immOrdersAndMovements.get('dateForFilter');
    const isCheckContributions = immOrdersAndMovements.get('isCheckContributions') ? 'FSC,' : '';
    const isCheckSubscription = immOrdersAndMovements.get('isCheckSubscription') ? 'FSU,' : '';
    const isCheckReimbursement = immOrdersAndMovements.get('isCheckReimbursement')
      ? 'FRE,FRM,'
      : '';
    const isCheckTransfer = immOrdersAndMovements.get('isCheckTransfer') ? 'FRI,FSI,FST' : '';
    const listCode =
      isCheckContributions + isCheckSubscription + isCheckReimbursement + isCheckTransfer;
    const totalList = listCode.length;
    const codeOperation = listCode[totalList - 1] === ',' ? listCode.slice(0, totalList - 1) : listCode;
    getNewFundMovements(immContract, stateOperation, date, codeOperation);
    openModal();
  }

  render() {
    const {
      isOpenModal,
      openModal,
      setStateOperationFilter,
      immOrdersAndMovements,
      setCheckContributions,
      setCheckSubscription,
      setCheckReimbursement,
      setCheckTransfer,
      setMinDateFilter,
      setMaxDateFilter,
    } = this.props;
    const stateOperation = immOrdersAndMovements.get('stateOperation');
    const isCheckContributions = immOrdersAndMovements.get('isCheckContributions');
    const isCheckSubscription = immOrdersAndMovements.get('isCheckSubscription');
    const isCheckReimbursement = immOrdersAndMovements.get('isCheckReimbursement');
    const isCheckTransfer = immOrdersAndMovements.get('isCheckTransfer');
    const dateForFilter = immOrdersAndMovements.get('dateForFilter');
    const modalContent = (
      <div className="broker-orders-and-movements-activity-filter">
        <div>
          <h5><FormattedText value="broker-ordersAndMovementsActivityStateOperation" /></h5>
          <hr></hr>
          <RadioButtonGroup
            name="stateOperation"
            idPrefix="stateOperationReasonRadio"
            selectedValue={stateOperation}
            onChange={e => setStateOperationFilter(e)}
          >
            <RadioButton
              label={formatText('broker-ordersAndMovementsPendingOption')}
              value={BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING}
            />
            <RadioButton
              label={formatText('broker-ordersAndMovementsExecutedOption')}
              value={BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED}
            />
            <RadioButton
              label={formatText('broker-ordersAndMovementsCancelledOption')}
              value={BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED}
            />
          </RadioButtonGroup>
        </div>
        <div>
          <h5><FormattedText value="broker-ordersAndMovementsActivityTypeOperation"/></h5>
          <hr/>
          <div className="broker-orders-and-movements-activity__new-filter-checkbox">
            <OKCheckbox
                idName="checkContributions"
                label={<FormattedText value="broker-ordersAndMovementsActivityPeriodicalContributions"/>}
                onChange={evt => setCheckContributions(evt.target.checked)}
                value={isCheckContributions}
            />
            <OKCheckbox
                idName="checkSubscription"
                label={<FormattedText value="broker-ordersAndMovementsActivitySubscription"/>}
                onChange={evt => setCheckSubscription(evt.target.checked)}
                value={isCheckSubscription}
            />
            <OKCheckbox
                idName="checkReimbursement"
                label={<FormattedText value="broker-ordersAndMovementsActivityReimbursement"/>}
                onChange={evt => setCheckReimbursement(evt.target.checked)}
                value={isCheckReimbursement}
            />
            <OKCheckbox
                idName="checkTransfer"
                label={<FormattedText value="broker-ordersAndMovementsActivityTransfer"/>}
                onChange={evt => setCheckTransfer(evt.target.checked)}
                value={isCheckTransfer}
            />
          </div>
        </div>
        <div>
          <DateFilter
            immFilter={dateForFilter}
            showFortnightly={false}
            showMonthly={false}
            showThreeMonths={true}
            onChangeMin={e => setMinDateFilter(e)}
            onChangeMax={e => setMaxDateFilter(e)}
          />
        </div>
      </div>
    );



    return (
      <OKModal
        content={modalContent}
        footerType="navigation"
        isOpen={isOpenModal}
        onCloseCallback={() => openModal()}
        onPrimaryButtonClick={this.onPrimaryButtonClick}
        onSecondaryButtonClick={this.onSecondaryButtonClick}
        primaryButtonText={formatText('broker-ordersAndMovementsPrimaryButtonModalFilter')}
        secondaryButtonText={formatText('broker-ordersAndMovementsSecondaryButtonModalFilter')}
        title={formatText('broker-ordersAndMovementsTitleModalFilter')}
      />
    );
  }
}

ModalOrderAndMovementsFilter.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  onHandledSearch: PropTypes.func.isRequired,
  immFilter: PropTypes.object.isRequired,
};

module.exports.constructor = ModalOrderAndMovementsFilter;
module.exports.ModalOrderAndMovementsFilter = connect(
  state => ({
    immOrdersAndMovements: state.brokerOrdersAndMovements,
  }),
  {
    setStateOperationFilter,
    setCheckContributions,
    setCheckSubscription,
    setCheckReimbursement,
    setCheckTransfer,
    getNewFundMovements,
    setMaxDateFilter,
    setMinDateFilter,
  }
)(withRouter(ModalOrderAndMovementsFilter));
